import { LocaleType } from '@hhgtech/hhg-components/types'

export type PriceInfoApi = {
  final: number
  regular: number
  discount_percent: number
}

export type AffiliateChanel = 'shopee' | 'tiki' | 'lazada' | 'hellobacsi'

export type ProductAffiliate = {
  channelCode: AffiliateChanel
  price: number
  url: string
}

export type PriceInfo = {
  final: number
  regular: number
  discountPercent: number
}

export type ProductPromotionApi = {
  id: number
  name: string
  thumbnail: string
  expiration_date: string
}

export type CategoryApi = {
  id: number
  name: string
  slug: string
  logo: string
  color?: string
  children?: CategoryApi[] | null
  products?: ProductApi[] | null
}

export type Category = {
  id: number
  name: string
  logo: string
  slug: string
  children?: Category[]
  backgroundColor?: string
  parentId?: number
  fullSlug: string
  products?: Product[]
}

export type ProductPromotion = {
  id: number
  name: string
  thumbnail: string
  expirationDate: string
}

export type ProductApi = {
  id: number
  price: PriceInfoApi
  thumbnail: string
  name: string
  average_rating: number
  reviews_count: number
  tag?: {
    id: number
    name: string
  } | null
  sku: string
  slug: string
  tags?: {
    id: number
    name: string
  }[]
  images?: {
    small: string
    medium: string
    large: string
  }[]
  unit?: string
  brand?: {
    name: string
    image: string
    slug: string
    products_count: number
  }
  product_promotions?: ProductPromotionApi[]
  description?: string
  categories?: CategoryApi[]
  is_in_stock?: boolean
  is_affiliate_product?: boolean
  affiliates?: {
    channel_code: 'shopee' | 'tiki' | 'lazada'
    price: number
    url: string
  }[]
}

export type Product = {
  id: number
  price: PriceInfo
  thumbnail: string
  name: string
  averageRating: number
  reviewsCount: number
  tag?: {
    id: number
    name: string
  } | null
  sku: string
  slug: string
  tags?: {
    id: number
    name: string
  }[]
  images: {
    small: string
    medium: string
    large: string
  }[]
  unit: string
  brand: {
    name: string
    image: string
    slug: string
    productsCount: number
  } | null
  productPromotions: ProductPromotion[]
  description: string
  categories?: Category[]
  isInStock?: boolean
  isAffiliateProduct?: boolean
  affiliates?: ProductAffiliate[]
}

export const COUNTRY_CURRENCY_SYMBOL: { [key in LocaleType]?: string } = {
  'vi-VN': '₫',
  'id-ID': 'Rp',
  'ms-MY': 'RM',
  'km-KH': '៛',
  'en-PH': '₱',
  'th-TH': '฿',
  'my-MM': 'K',
  'zh-TW': '$', // New Taiwan Dollar can be written as NTD$ or $
  'hi-IN': '₹',
}
